import React, { useState } from "react";
import ".././sidebar.scss";
import NavItem from "./navItem/NavItem.js";
import EB_LOGO_Full from "../../../../assets/images/EB_Logo_white_text.svg";
import EB_LOGO from "../../../../assets/images/symbol.svg";
import { NavLink } from "react-router-dom";
import { SettingsIcon, LogoutIcon, HelpIcon, redirectIcon } from "../../../../constants";
import { ReactComponent as RedirectIcon } from "../../../../assets/images/redirect.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./navItem/navItem.scss";
import { Popover } from "antd";
import { Text1, Text3, Text4 } from "../../../../styles";

const PrimarySidebar = (props) => {
  const { menu, logout, merchant_data } = props;
  const sidebarCollapsed = false;
  const [isExpanded, setIsExpanded] = useState(sidebarCollapsed);
  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
  };

  const renderTitle = () => {
    return (
      <div style={{marginBottom:"16px", marginTop:"5px"}}>
      <Text1 className="p-2" strong>Help</Text1>
        </div>
    )
};
  const renderContent = (
    <div style={{ top: "465px", left: "55px", borderRadius: "10px"}}>
      {renderTitle()}
      <Text4 className="help">RM Details</Text4>
      <div className="d-flex" style={{margin:"0px", fontSize:"14px", flexDirection:"column"}}>
      <Text4 className="ml-2"> {`Name : ${props?.merchant_data?.support?.rm_name || "---" }`}</Text4>
      <Text4 className="ml-2"> {`Mobile : ${props?.merchant_data?.support?.rm_phone || "---"}`}</Text4>
      <Text4 className="ml-2">{`Email ID : ${props?.merchant_data?.support?.rm_email || "---"}`}</Text4>
      <Text4 className="ml-2">{`Toll-free No. : 1800 891 8297`}</Text4>
      </div>

      <a
        className="help d-flex align-items-center"
        href={merchant_data && merchant_data.env === "prod" ? "https://easebuzz.in/contact/" : "https://dev.easebuzz.in/contact/"}
        target="_blank"
      >
        <div className="mr-2">Write to Us </div>
        <RedirectIcon fill="red" className="redirect_icon" />
      </a>

      <a href={"https://docs.easebuzz.in/docs/neobanking/"} target="_blank" className="help d-flex align-items-center">
      <div className="mr-2">Documentation</div>
        <RedirectIcon fill="red" className="redirect_icon" />
        </a>
  </div>
  )

  const renderHelpDetails = () =>{
    return(
      <div className="help-popover">
        <Popover
          content={renderContent}
          placement="right"
          trigger="click"
        >
          <img className="navIcon" src={HelpIcon} alt="" />
          <span className="navLabel">Help</span>
          <span className="navItem-tooltip">Help</span></Popover>
      </div>
      
    )

  }


  return (

    <div className="primary_sidebar_wrapper">
      <nav className={`${isExpanded ? `primary_sidebar` : `collapsed_primary_sidebar` }`}>
        <div>
          <div className="sidebar_top primary_divider_border">
            {isExpanded ? (
              <img
                style={{ width: "70%", height: "70%" }}
                src={EB_LOGO_Full}
                alt=""
              />
            ) : (
              <img style={{ height: "60%" }} src={EB_LOGO} />
            )}
          </div>

          <div onClick={toggleSidebar} className="toggle_button">
            {isExpanded ? (
              <FontAwesomeIcon icon={faTimes} size="1x" color="white" />
            ) : (
              <FontAwesomeIcon icon={faBars} color="white" />
            )}
          </div>

          <div className="primary_sidebar_nav_list">
            {menu.map((item, index) => {
              return (
                <NavItem
                  key={`${item.label}-${index}`}
                  isExpanded={isExpanded}
                  item={item}
                />
              );
            })}
          </div>
        </div>
        <div className="sidebar_footer" >
          {/* <a
            href={merchant_data && merchant_data.env === "prod" ? "https://easebuzz.in/contact/" : "https://dev.easebuzz.in/contact/"}
            target="_blank"
            className="navItem"
          > */}
            {/* <img className="navIcon" src={HelpIcon} alt="" />
            <span className="navLabel">Help</span>
            <span className="navItem-tooltip">Help</span> */}

            <span className="navItem">
            {renderHelpDetails()}
            </span>
          {/* </a> */}
          <NavLink
            exact
            to="/settings"
            className="navItem"
          >
            <img className="navIcon" src={SettingsIcon} alt="" />
            <span className="navLabel">Settings</span>
            <span className="navItem-tooltip">Settings</span>
          </NavLink>

          <span onClick={logout} className="navItem">
            <img className="navIcon" src={LogoutIcon} alt="" />
            <span className="navLabel">Logout</span>
            <span className="navItem-tooltip">Logout</span>
          </span>
        </div>
      </nav>
    </div>
  );
};

export default PrimarySidebar;
